var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-level-wrap"},[_c('p',{staticClass:"text-right pr-5 mt-5"},[_c('span',{staticClass:"text-link h4",on:{"click":function($event){return _vm.$emit('closePanel')}}},[_vm._v("关闭")])]),_c('div',{staticClass:"text-left",attrs:{"id":"AccountLevel"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }